import { Component, OnInit } from '@angular/core';
import { HeaderFooterVisibilityService } from '@app/shared/services/header-footer-visibility.service';

@Component({
  selector: 'app-register-success',
  templateUrl: './register-success.component.html',
  styleUrls: ['./register-success.component.scss'],
})
export class RegisterSuccessComponent implements OnInit {
  constructor(private headerFooterVisibilityService: HeaderFooterVisibilityService) {}

  ngOnInit() {
    this.headerFooterVisibilityService.isFooterVisible = false;
  }

  goToLogin() {
    const hostNameAndPath = `${window.location.host}/auth/login`;
    window.location.href = `${window.location.protocol}//${hostNameAndPath}`;
  }
}
